import React, { useState } from "react";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { Link } from "react-router-dom";
import contactApi from "../../api/contactApi";
import useAlphabetsInput from "../../hooks/useAlphabeticInput";
import useNumericInput from "../../hooks/useNumericInput";
import { Container, Row, Col, Form } from "react-bootstrap";
import { Mail, Phone, MapPin, Clock, MessageCircle } from "lucide-react";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import Breadcrump from "../../Components/Breadcrump";
import { showError, showSuccess } from "../../utils/toastUtils";

function ContactUs() {
  useAlphabetsInput();
  useNumericInput();
const { siteConfig } = useSiteConfig();
  const INITAL_FORM_DATA = {
    email: "",
    phone: "",
    name: "",
    message: "",
  };

  const [formData, setFormData] = useState(INITAL_FORM_DATA);
  const [errors, setErrors] = useState({});

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(formData.email);

  const validate = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Please enter email address";
    } else if (!isValidEmail) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.phone) {
      newErrors.phone = "Please enter phone";
    }

    if (!formData.name) {
      newErrors.name = "Please enter name";
    }

    if (!formData.message) {
      newErrors.message = "Please enter message";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      const res = await contactApi.contact_detail(formData);
      if (res.code === 200) {
        showSuccess(res.message);
        setFormData(INITAL_FORM_DATA);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <Breadcrump title="Contact Us" />

      <div className="contact-page-wrapper">
        {/* Hero Header */}
        <section className="contact-hero text-center py-5">
          <Container>
            <span className="subtitle">Get In Touch</span>
            <h1 className="section-title mt-2">We'd Love to Hear From You</h1>
            <p className="contact-hero-desc mx-auto mt-3">
              For any questions or queries, whether you're already a customer or
              a potential customer, feel free to reach out to our friendly and
              knowledgable customer support team.
            </p>
          </Container>
        </section>

        <Container className="pb-5">
          <div className="contact-card-container shadow-sm">
            <Row className="g-0">
              {/* Left Side: Info */}
              <Col lg={5} className="info-panel p-md-5 p-4 text-white">
                <h3 className="contact-title mb-4">Contact Information</h3>

                <div className="info-item d-flex align-items-start mb-4">
                  {/* <div className="info-icon">
                    <Clock size={16} />
                  </div> */}
                  
                </div>

                <div className="info-item d-flex align-items-start mb-4">
                  <div className="info-icon">
                    <MapPin size={16} />
                  </div>
                  <div>
                    <h6>Address</h6>
                    <a href="#" className="contact-info">
                      {[
                        siteConfig?.address,
                       
                      ]
                        .filter(Boolean)
                        .join(", ")}
                      {siteConfig?.address?.pincode
                        ? ` - ${siteConfig?.address.pincode}`
                        : ""}
                    </a>
                  </div>
                </div>

                <div className="info-item d-flex align-items-start mb-4">
                  <div className="info-icon">
                    <MessageCircle size={16} />
                  </div>
                  <div>
                    <h6>Whatsapp Here</h6>
                    <a
                      className="contact-info"
                      href={`https://wa.me/${siteConfig?.whatsapp}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                       {siteConfig?.whatsapp}
                    </a>
                  </div>
                </div>

                <div className="info-item d-flex align-items-start mb-4">
                  <div className="info-icon">
                    <Phone size={16} />
                  </div>
                  <div>
                    <h6>Phone number</h6>
                    <a className="contact-info" href={`tel:+91${siteConfig?.phone}`}>
                       {siteConfig?.phone}
                    </a>
                  </div>
                </div>

                <div className="info-item d-flex align-items-start mb-4">
                  <div className="info-icon">
                    <Mail size={16} />
                  </div>
                  <div>
                    <h6>Email</h6>
                    <a className="contact-info" href={`mailto:${siteConfig?.email}`}>
                      {siteConfig?.email}
                    </a>
                  </div>
                </div>

                <p className="contact-note">
                  Please note that during public holidays, our response may take
                  longer than usual. We will always respond as soon as possible.
                </p>

                <ul className="social-icons d-flex gap-3 pt-4 border-top border-light-subtle list-unstyled m-0">
                  {siteConfig?.socialMedia?.facebook && (
                    <li>
                      <a href={siteConfig?.socialMedia?.facebook} target="_blank" rel="noreferrer" className="social-icon">
                        <FaFacebook size={15} />
                      </a>
                    </li>
                  )}
                  {siteConfig?.socialMedia?.instagram && (
                    <li>
                      <a href={siteConfig?.socialMedia?.instagram} target="_blank" rel="noreferrer" className="social-icon">
                        <FaInstagram size={15} />
                      </a>
                    </li>
                  )}
                  {siteConfig?.socialMedia?.twitter && (
                    <li>
                      <a href={siteConfig?.socialMedia?.twitter} target="_blank" rel="noreferrer" className="social-icon">
                        <FaTwitter size={15} />
                      </a>
                    </li>
                  )}
                  {siteConfig?.socialMedia?.youtube && (
                    <li>
                      <a href={siteConfig?.socialMedia?.youtube} target="_blank" rel="noreferrer" className="social-icon">
                        <FaYoutube size={15} />
                      </a>
                    </li>
                  )}
                  {siteConfig?.socialMedia?.linkedin && (
                    <li>
                      <a href={siteConfig?.socialMedia?.linkedin} target="_blank" rel="noreferrer" className="social-icon">
                        <FaLinkedin size={15} />
                      </a>
                    </li>
                  )}
                </ul>
              </Col>

              {/* Right Side: Form */}
              <Col lg={7} className="form-panel p-md-5 p-4 bg-white">
                <h4 className="form-heading mb-4 text-center">Send Us a Message</h4>
                <Form method="post" onSubmit={handleSubmit}>
                  <Row className="g-4">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label htmlFor="name">
                          Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          className="custom-input only-alphabets"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                        {errors.name && (
                          <span className="error-text">{errors.name}</span>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label htmlFor="email">
                          Email Address <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          className="custom-input"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                        {errors.email && (
                          <span className="error-text">{errors.email}</span>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label htmlFor="username">
                          Phone Number <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          className="custom-input only-numeric"
                          type="text"
                          maxLength={10}
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                        {errors.phone && (
                          <span className="error-text">{errors.phone}</span>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <Form.Group>
                        <Form.Label htmlFor="mess">
                          Message <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          placeholder="Tell us more about your requirements..."
                          className="custom-input"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          required
                        />
                        {errors.message && (
                          <span className="error-text">{errors.message}</span>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={12} className="mt-4">
                      <button className="submit-btn w-100" type="submit">
                        Send Message
                      </button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>

        {siteConfig?.address?.mapLocation && (
          <div className="wg-map">
            <iframe
              src={siteConfig?.address?.mapLocation}
              className="map"
              style={{ border: "none" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        )}
      </div>
    </>
  );
}

export default ContactUs;